import { Colors } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

export default class Button extends Lightning.Component {
  static _template() {
    return {
      collision: true,
      rect: true,
      w: 235,
      h: 70,
      y: 770,
      x: 840,
      color: Colors('#292929').get(),
      texture: Lightning.Tools.getRoundRect(240, 75, 12, 3, false),
      Wrapper: {
        w: 235,
        h: 70,
        flex: { justifyContent: 'center', alignItems: 'center' },
        y: 3,
        Text: {
          text: {
            text: 'Done',
            fontSize: 32,
            fontFace: 'OpenSans-Regular',
            textColor: Colors('#ffffff').get(),
            textAlign: 'center',
          },
        },
      },
      FocusBorder: {},
    };
  }
  get _FocusBorder() {
    return this.tag('FocusBorder');
  }

  _firstEnable() {
    this._FocusBorder.patch({
      w: 235,
      h: 70,
      texture: Lightning.Tools.getRoundRect(240, 75, 12, 3, Colors('#d6d6d7').get(), false),
    });
  }

  _focus() {
    this._FocusBorder.patch({
      texture: Lightning.Tools.getRoundRect(240, 75, 12, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._FocusBorder.patch({
      texture: Lightning.Tools.getRoundRect(240, 75, 12, 3, Colors('#d6d6d7').get(), false),
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Button'), this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }
}
